import one from '../assets/svg/projects/one.webp'
import two from '../assets/svg/projects/two.webp'
import three from '../assets/svg/projects/three.webp'
import four from '../assets/svg/projects/four.webp'

export const projectsData = [
    {
        id: 1,
        projectName: 'مارکتینگ',
        projectDesc: 'استراتژی بازاریابی، پخش و فروش محصولات آرایشی و بهداشتی',
        tags: ['مطالعه بیشتر'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'Marketing',
        image: one
    },
    {
        id: 2,          
        projectName: 'آموزش',
        projectDesc: 'آموزش  مطالب آرایشی و بهداشتی ',
        tags: ['مطالعه بیشتر'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'train',
        image: two
    },
    {
        id: 3,
        projectName: 'تحقیق و توسعه',
        projectDesc: 'تحقیق و توسعه در عرصه محصولات آرایشی و بهداشتی',
        tags: ['مطالعه بیشتر'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'skills',
        image: three
    },
    {
        id: 4,
        projectName: 'عطر، ادکلن و اسانس',
        projectDesc: 'انواع حالت‌های عطر،انواع رایحه ها،راهکارهایی برای افزایش ماندگاری عطر',
        tags: ['مطالعه بیشتر'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'Projects',
        image: four
    },
   
]
